module.exports = "/_next/static/images/logo-0f0e661d99ecd18675dd923b11a676ce.svg";